import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CapitalizePipe } from '../../../../pipes/capitalize-text';

@Component({
  selector: 'app-status',
  standalone: true,
  imports: [TranslateModule, CommonModule, CapitalizePipe],
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss',
})
export class StatusComponent {
  @Input() statuses: string[] = [];
  @Input() title: string = 'STATUS';
  @Input() includeAll: boolean = true;
  @Input() useTranslate: boolean = true;
  @Output() close = new EventEmitter<string>();

  isStatusOpen = false;
  selectedOption: string = 'ALL';

  get sortingTypeDictionary(): string[] {
    return this.includeAll ? ['ALL', ...this.statuses] : [...this.statuses];
  }

  toggleModal(option?: string) {
    if (option) {
      this.selectedOption = this.sortingTypeDictionary.includes(option)
        ? option
        : this.selectedOption;
      this.close.emit(option);
    }
    this.isStatusOpen = !this.isStatusOpen;
  }

  capitalize(text: string): string {
    if (!text) return '';
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
}
